import type { ApiDailyRewardCheckInRes } from "@bridge-applications/pb-types";
import type { DailyRewardSlice } from "../../schemas/slices/DailyRewardSliceSchema";

type DailyRewardCheckInOk = Extract<ApiDailyRewardCheckInRes, { status: "OK" }>;

export function applyDailyRewardCheckIn(
    current: DailyRewardSlice,
    response: DailyRewardCheckInOk,
    openWhenRewardedNow: boolean,
): DailyRewardSlice {
    // A cached response keeps rewardedNow=true after the user has claimed or
    // dismissed it. Only unseen server grants start a new presentation.
    const knownGrantIds = new Set(current.grants.map((grant) => grant.grantId));
    const hasNewReward =
        response.rewardedNow &&
        response.grants.some((grant) => !knownGrantIds.has(grant.grantId));
    const claimState = hasNewReward
        ? "claimable"
        : response.rewardedNow
          ? current.claimState
          : "claimed";
    const pendingSlotSnapshot = hasNewReward
        ? response.slotSnapshot
        : response.rewardedNow
          ? current.pendingSlotSnapshot
          : null;

    return {
        ...current,
        snapshot: response.dailyReward,
        grants: response.grants,
        loadStatus: "ready",
        loadError: null,
        claimState,
        pendingSlotSnapshot,
        isDialogOpen:
            current.isDialogOpen || (openWhenRewardedNow && hasNewReward),
    };
}
